(function() {
  function buildAvailabilityToggles(panel) {
    if (panel.querySelector('.availability-toggles')) return;

    var filters = window.collection && window.collection.filters ? window.collection.filters.all : [];
    var appliedFilters = window.collection && window.collection.filters ? window.collection.filters.applied : {};

    var availActive = !!(appliedFilters['filter.v.availability'] && appliedFilters['filter.v.availability'].indexOf('1') > -1);
    var customActive = false;
    var newActive = false;
    var customFilterKey = '';
    var customFilterValue = 'customring';
    var newFilterKey = '';
    var newFilterValue = 'new_engagement';
    var availCount = 0;
    var customCount = 0;
    var newCount = 0;

    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      if (f.key === 'filter.v.availability') {
        for (var j = 0; j < f.options.length; j++) {
          if (f.options[j].value === '1') {
            availCount = f.options[j].count || 0;
          }
        }
      }
      if (f.options) {
        for (var k = 0; k < f.options.length; k++) {
          var opt = f.options[k];
          var valLower = (opt.value || '').toLowerCase();
          if (valLower === 'customring' || opt.value === 'customring') {
            customFilterKey = f.key;
            customFilterValue = opt.value;
            customCount = opt.count || 0;
            if (opt.active) customActive = true;
          }
          if (valLower === 'new_engagement' || opt.value === 'new_engagement') {
            newFilterKey = f.key;
            newFilterValue = opt.value;
            newCount = opt.count || 0;
            if (opt.active) newActive = true;
          }
        }
      }
    }

    panel.innerHTML = '<div class="availability-toggles">' +
      '<div class="availability-toggles__item">' +
        '<div class="availability-toggles__info">' +
          '<span class="availability-toggles__title">Ready to ship <span class="availability-toggles__count">(' + availCount + ')</span></span>' +
          '<span class="availability-toggles__desc">In stock \u00b7 ships in 2\u20134 days</span>' +
        '</div>' +
        '<label class="toggle-switch">' +
          '<input type="checkbox"' + (availActive ? ' checked' : '') + ' onchange="Collection.filter(\'filter.v.availability\', \'1\')">' +
          '<span class="toggle-switch__slider"></span>' +
        '</label>' +
      '</div>' +
      '<div class="availability-toggles__item">' +
        '<div class="availability-toggles__info">' +
          '<span class="availability-toggles__title">Personalize <span class="availability-toggles__count">(' + customCount + ')</span></span>' +
          '<span class="availability-toggles__desc">Choose stone &amp; metal</span>' +
        '</div>' +
        '<label class="toggle-switch">' +
          '<input type="checkbox"' + (customActive ? ' checked' : '') + ' onchange="Collection.filter(\'' + (customFilterKey || 'filter.p.tag') + '\', \'' + customFilterValue + '\')">' +
          '<span class="toggle-switch__slider"></span>' +
        '</label>' +
      '</div>' +
      '<div class="availability-toggles__item">' +
        '<div class="availability-toggles__info">' +
          '<span class="availability-toggles__title">New this Month <span class="availability-toggles__count">(' + newCount + ')</span></span>' +
          '<span class="availability-toggles__desc">New drops every Thursday</span>' +
        '</div>' +
        '<label class="toggle-switch">' +
          '<input type="checkbox"' + (newActive ? ' checked' : '') + ' onchange="Collection.filter(\'' + (newFilterKey || 'filter.p.tag') + '\', \'' + newFilterValue + '\')">' +
          '<span class="toggle-switch__slider"></span>' +
        '</label>' +
      '</div>' +
    '</div>';
  }

  function initAvailabilityToggles() {
    var dd = document.querySelector('.collection-inline-filters__dd[data-filter-key="filter.v.availability"]');
    if (!dd) return;
    var panel = dd.querySelector('.collection-inline-filters__panel');
    if (!panel) return;
    buildAvailabilityToggles(panel);
  }

  function scheduleInit() {
    requestAnimationFrame(function() {
      setTimeout(initAvailabilityToggles, 50);
    });
  }

  window.addEventListener('Collection:loaded', scheduleInit);

  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (target.closest && target.closest('.collection-inline-filters__dd[data-filter-key="filter.v.availability"]')) {
        setTimeout(initAvailabilityToggles, 10);
        return;
      }
    }
  });

  function startObserver() {
    var container = document.querySelector('.collection-inline-filters');
    if (container) {
      observer.observe(container, { childList: true, subtree: true });
    }
    initAvailabilityToggles();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(startObserver, 200);
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(startObserver, 200);
    });
  }
})();
